export const JOB_OUTCOMES = [
  { value: 'device_decommissioned', label: 'Device decommissioned' },
  { value: 'device_replaced', label: 'Device replaced' },
  { value: 'job_aborted', label: 'Job aborted' },
  { value: 'antenna_replaced', label: 'Antenna replaced' },
  { value: 'both_device_and_antenna_replaced', label: 'Both device and antenna replaced' },
  { value: 'device_installed', label: 'Device installed' },
  { value: 'no_fault_found', label: 'No fault found' },
] as const

export const ABORTED_REASONS = [
  { value: 'site_seized', label: 'Site seized' },
  { value: 'road_traffic_management_required', label: 'Road traffic management required' },
  { value: 'customer_private_property', label: 'Customer / private property' },
  { value: 'private_land', label: 'Private land' },
  { value: 'sws_action_required', label: 'SWS action required' },
  { value: 'existing_device_working', label: 'Existing device working' },
] as const

export type JobOutcomeType = (typeof JOB_OUTCOMES)[number]['value']
export type AbortedReason = (typeof ABORTED_REASONS)[number]['value']
export type CompletedJobOutcome = Exclude<JobOutcomeType, 'job_aborted'>

export const COMPLETED_JOB_OUTCOMES = JOB_OUTCOMES.filter(
  (
    outcome
  ): outcome is Exclude<(typeof JOB_OUTCOMES)[number], { value: 'job_aborted' }> =>
    outcome.value !== 'job_aborted'
)

export const COMPLETED_JOB_OUTCOME_VALUES: readonly CompletedJobOutcome[] =
  COMPLETED_JOB_OUTCOMES.map((outcome) => outcome.value)

export const ABORTED_REASON_VALUES: readonly AbortedReason[] = ABORTED_REASONS.map(
  (reason) => reason.value
)
